/**
 * Role Badge Component
 * 
 * Color-coded badge for displaying user roles
 * Part of E007-S026: Team Management
 */

import React from 'react';

interface RoleBadgeProps {
  role: 'admin' | 'manager' | 'analyst' | 'viewer';
  className?: string;
}

const roleStyles = {
  admin: 'bg-red-100 text-red-800 border-red-200',
  manager: 'bg-blue-100 text-blue-800 border-blue-200',
  analyst: 'bg-green-100 text-green-800 border-green-200',
  viewer: 'bg-gray-100 text-gray-800 border-gray-200',
};

const roleLabels = {
  admin: 'Admin',
  manager: 'Manager',
  analyst: 'Analyst',
  viewer: 'Viewer',
};

export const RoleBadge: React.FC<RoleBadgeProps> = ({ role, className = '' }) => {
  const styles = roleStyles[role];
  const label = roleLabels[role];

  return (
    <span
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border ${styles} ${className}`}
    >
      {label}
    </span>
  );
};
